<template>
    <v-card tile style=" margin-right: 10px; margin-bottom: 10px">
        <v-toolbar flat color="white">
            <v-layout row>
                <v-flex shrink>
                    <span style="color: grey; font-size: 14px">{{title}}</span>
                </v-flex>
                <v-flex grow class="text-xs-right" style="margin-right: -10px">
                    <v-chip :outline="articleRepresentation !== 'Table'"   small :color="'#b4b4b0'" :text-color="articleRepresentation === 'Table' ? 'white' : ''" @click="articleRepresentation = 'Table'" style="cursor: pointer">Tabela</v-chip>
                    <v-chip :outline="articleRepresentation !== 'Graphic'" small :color="'#b4b4b0'" :text-color="articleRepresentation === 'Graphic' ? 'white' : ''" @click="articleRepresentation = 'Graphic'" style="cursor: pointer">Gráfico</v-chip>
                </v-flex>
            </v-layout>
        </v-toolbar>
        <p v-if="!hasData" style="color: #7f7f7f; font-weight: bold; margin-left: 20px; padding-bottom: 10px;">Nenhum dado</p>
        <div v-else>
            <pie-chart v-if="articleRepresentation === 'Graphic' && canShow" :mData="tablesDatasets" :mLabels="tablesDatalabels" style="padding: 10px; min-height: 400px"></pie-chart>
            <v-data-table v-if="articleRepresentation === 'Table'"
                          :headers="headers"
                          :items="filteredItems"
                          no-data-text="Nenhum artigo ainda"
                          no-results-text="nenhum resultado"
                          rows-per-page-text="por página"
                          disable-initial-sort
                          hide-actions
            >
                <template slot="items" slot-scope="props">
                    <td class="text-xs-left">{{ props.item.name }}</td>
                    <td class="text-xs-right">{{ props.item.total | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' }) }} ECV</td>
                </template>
            </v-data-table>
        </div>

    </v-card>
</template>

<script>
    import PieChart from "../graphs/PieChart.js";
    export default {
        name: "DataViewerSwitch",

        mounted(){
            this.prepareTablesDataSet(this.filteredItems);
        },

        data(){
            return {
                canShow: false,
                hasData: false,
                articleRepresentation: 'Graphic',
                headers: [
                    { text: 'Nome', align: 'left', value: 'name', sortable: true },
                    { text: 'Valor Total', align: 'right', value: 'total', sortable: true },
                ],


                tablesDatasets: [],
                tablesDatalabels: [],
            }
        },

        props: ['title', 'filteredItems', 'dataset', 'labels'],

        components: {
            PieChart,
        },

        methods: {
            prepareTablesDataSet(response){
                this.canShow = false;
                this.hasData = false;
                let mArray = [];
                let dataArray = [], labelsArray = [];

                let total = 0, othersCost = 0;
                for (let i = 0; i < response.length; i++) {
                    total += response[i].total;
                    if(i > 4){
                        othersCost += response[i].total;
                    }
                }

                for (let i = 0; i < response.length && i <= 4; i++) {
                    let label = response[i].name;
                    let percentage = this.getPercentage(response[i].total, total);

                    dataArray.push(response[i].total);
                    labelsArray.push(label+'('+percentage+'%)');
                }

                if(othersCost > 0){
                    dataArray.push(othersCost);
                    let percentage = this.getPercentage(othersCost, total);
                    labelsArray.push('outros'+'('+percentage+'%)');
                }

                mArray.push({
                    'data': dataArray,
                    'labels': labelsArray,
                    'backgroundColor': "rgba(251, 140, 0, 0.2)",
                    'label': "",
                });
                this.tablesDatasets = JSON.stringify(dataArray);
                this.tablesDatalabels = JSON.stringify(labelsArray);
                this.canShow = true;

                this.hasData = response.length > 0;
            },

            getPercentage(value, valueReference){
                return this.roundToTwoDecimals(value * 100 / valueReference);
            }
        }
    }
</script>

<style scoped>

</style>